<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">祝日管理</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="modified" rounded depressed small @click="onRefresh()">
              <span class="px-1 text-none">中止</span>
            </v-btn>
            <v-btn v-if="modified" dark rounded depressed small color="error" class="mx-1" @click.native="updateDialog = true">
              <span class="text-none">変更</span>
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="start" justify="start">
          <v-col cols="12" class="pa-0" align="end">
            <input @change="select" type="file" name="file" accept="text/csv" ref="file">
            <v-chip @click="onFile()" small color="primary"><v-icon v-if="!file" class="pr-1">mdi-file-document-box-search</v-icon><span>{{ fileName ? fileName : '選択してください' }}</span></v-chip>
            <v-btn v-if="file != null" dark depressed fab x-small @click="onReset()" color="error" class="ml-2"><v-icon >mdi-close</v-icon></v-btn>
            <v-btn rounded depressed small color="error" :disabled="file == null"  class="mx-2" @click.native="upload = true">
              <span class="text-none">保存</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" align="start" justify="start">
          <v-col cols="6" class="py-0 pl-0">
            <v-row class="ma-0 py-0" align="center">
              <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <template v-for="(header, index) in headers">
                    <v-col :cols="header.width" :align="header.align" class="pa-0" :key="header.key">
                      <v-sheet class="pa-0 customHeader" color="transparent">
                        <template v-if="header.key == 'number'">
                          <v-row class="ma-0 pa-0" align="center">
                            <v-col cols="3" class="pa-0">
                              <span>#</span>
                            </v-col>
                            <v-col cols="9" class="pa-0">
                            </v-col>
                          </v-row>
                        </template>
                        <template v-else-if="header.valid">
                          <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                          <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                        </template>
                        <template v-else>
                          <span>{{ header.title }}</span>
                        </template>
                      </v-sheet>
                    </v-col>
                  </template>
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto'>
                  <RecycleScroller
                    class="scroller"
                    :items="filterItems"
                    :item-size="44"
                    key-field="key"
                  >
                    <template v-slot="{ item, index }">
                      <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                        <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;" @click.stop="onSelect(item)">
                          <template v-for="(header) in headers">
                            <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                              <template v-if="header.key == 'number'">
                                <v-row class="ma-0 pa-0" align="center">
                                  <v-col cols="3" class="pa-0">
                                    <span class="overflow-text-hidden">{{ index + 1 }}</span>
                                  </v-col>
                                  <v-col cols="9" class="pa-0">
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else-if="header.key == 'enable'">
                                <v-checkbox
                                  v-if="!file"
                                  v-model="item.enable"
                                  color="error"
                                  dense
                                  hide-details
                                  @change="modified = true"
                                  class="ma-0 pa-0"
                                ></v-checkbox>
                              </template>
                              <template v-else-if="header.key == 'delete'">
                                <v-btn icon @click.stop.prevent="onRemoveDialog(item)">
                                  <v-icon color="error">mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <template v-else>
                                <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                              </template>
                            </v-col>
                          </template>
                        </v-row>
                      </v-sheet>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-row class="ma-0 py-0" align="center">
              <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <template v-for="(header, index) in fileHeaders">
                    <v-col :cols="header.width" :align="header.align" class="pa-0" :key="header.key">
                      <v-sheet class="pa-0 customHeader" color="transparent">
                        <template v-if="header.key == 'number'">
                          <v-row class="ma-0 pa-0" align="center">
                            <v-col cols="3" class="pa-0">
                              <span>#</span>
                            </v-col>
                            <v-col cols="9" class="pa-0">
                              <v-checkbox
                                v-if="file"
                                v-model="all"
                                color="primary"
                                @change="onChangeSelectedAll()"
                                dense
                                hide-details
                                class="ma-0 pa-0"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-else-if="header.valid">
                          <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                          <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                        </template>
                        <template v-else>
                          <span>{{ header.title }}</span>
                        </template>
                      </v-sheet>
                    </v-col>
                  </template>
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto'>
                  <RecycleScroller
                    class="scroller"
                    :items="items"
                    :item-size="44"
                    key-field="startDate"
                  >
                    <template v-slot="{ item, index }">
                      <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                        <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                          <template v-for="(header) in fileHeaders">
                            <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                              <template v-if="header.key == 'number'">
                                <v-row class="ma-0 pa-0" align="center">
                                  <v-col cols="3" class="pa-0">
                                    <span class="overflow-text-hidden">{{ index + 1 }}</span>
                                  </v-col>
                                  <v-col cols="9" class="pa-0">
                                    <v-checkbox
                                      v-if="file"
                                      v-model="selected[item.startDate]"
                                      color="primary"
                                      @change="onChangeSelected(item)"
                                      dense
                                      hide-details
                                      class="ma-0 pa-0"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else-if="header.key == 'delete'">
                                <v-btn icon @click.stop.prevent="dialog = true">
                                  <v-icon color="error">mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <template v-else>
                                <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                              </template>
                            </v-col>
                          </template>
                        </v-row>
                      </v-sheet>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <app-basic-dialog
        v-if="upload"
        @dismissed="onDismissed"
        title='保存'
        message="祝日データを保存します。よろしいですか?"
        :dialog='upload'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if="updateDialog"
        @dismissed="onDismissed"
        title='保存'
        message="祝日データを変更ます。よろしいですか?"
        :dialog='updateDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if="dialog"
        @dismissed="onDismissed"
        title='削除'
        message="祝日データを削除します。よろしいですか?"
        :dialog='dialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import * as async from 'async'
import * as Papa from 'papaparse'
export default {
  computed: {
    ...mapGetters({
      holidays: 'holidays/holidays',
      windowSize: 'shared/windowSize'
    }),
    filterItems () {
      var temp = []
      for (var i in this.holidays) {
        var payload = JSON.parse(JSON.stringify(this.holidays[i]))
        if (typeof payload.enable === 'undefined') {
          payload['enable'] = true
        }
        temp.push(payload)
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    },
    dataHeight () {
      return Number(this.windowSize.y - 60 - 60 - 56 - 40)
    }
  },
  data () {
    return {
      headers: [
        { valid: false, over: false, value: 2, title: '#', key: 'number', width: '2', align: 'start' },
        { valid: true, over: false, value: 2, title: '名称', key: 'name', width: '8', align: 'start' },
        { valid: false, over: false, value: 2, title: '有効', key: 'enable', width: '1', align: 'center' },
        { valid: false, over: false, value: 2, title: '', key: 'delete', width: '1', align: 'end' }
      ],
      fileHeaders: [
        { valid: false, over: false, value: 2, title: '#', key: 'number', width: '2', align: 'start' },
        { valid: true, over: false, value: 2, title: '日付', key: 'startDate', width: '4', align: 'start' },
        { valid: false, over: false, value: 2, title: '名称', key: 'title', width: '6', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      all: false,
      upload: false,
      dialog: false,
      updateDialog: false,
      loading: false,
      file: null,
      fileName: null,
      item: null,
      items: [],
      selected: {},
      modified: false
    }
  },
  created () {
  },
  methods: {
    async select (e) {
      this.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(500).then(() => {
        this.fileRead(e)
      })
    },
    fileRead (e) {
      var vm = this
      vm.file = null
      vm.items = []
      vm.selected = {}
      e.preventDefault()
      let files = e.target.files
      if (files.length === 0) {
        return
      }
      this.file = files[0]
      this.fileName = this.file.name
      var reader = new FileReader()
      reader.onerror = function () {
        console.log('error')
      }
      reader.onload = function () {
        Papa.parse(files[0], {
          encoding: 'Shift-JIS',
          header: false,
          complete: function (results) {
            console.log(vm.selected)
            for (var i in results.data) {
              var m = moment(results.data[i][0])
              if (m.isValid()) {
                moment.tz.setDefault('Asia/Tokyo')
                var payload = {
                  startDate: m.format('YYYY-MM-DD'),
                  start: {
                    date: m.format('YYYY-MM-DD'),
                    yyyy: parseInt(m.format('YYYY')),
                    mm: parseInt(m.format('MM')),
                    dd: parseInt(m.format('DD'))
                  },
                  endDate: m.format('YYYY-MM-DD'),
                  end: {
                    date: m.format('YYYY-MM-DD'),
                    yyyy: parseInt(m.format('YYYY')),
                    mm: parseInt(m.format('MM')),
                    dd: parseInt(m.format('DD'))
                  },
                  period: 1,
                  category: 0,
                  type: 'holiday',
                  title: results.data[i][1]
                }
                vm.selected[payload.startDate] = false
                vm.items.push(payload)
              }
            }
            vm.loading = false
          },
          error () {
            vm.loading = false
          }
        })
      }
      vm.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      pause(300).then(() => {
        reader.readAsArrayBuffer(this.file)
      })
    },
    onRefresh () {
      this.onReset()
      this.modified = false
    },
    onReset () {
      this.$refs.file.value = null
      this.file = null
      this.fileName = null
      this.item = null
      this.items = []
      this.selected = {}
    },
    onFile () {
      this.$refs.file.click()
    },
    onSelect (item) {
      if (this.file) {
        this.onReset()
      }
      this.item = JSON.parse(JSON.stringify(item))
      this.items = this.item.events
    },
    onChangeSelectedAll () {
      var keys = Object.keys(this.selected)
      var temp = {}
      for (var i in keys) {
        temp[keys[i]] = this.all
      }
      this.selected = temp
    },
    onChangeSelected (item) {

    },
    onUpdate () {
      var vm = this
      this.loading = true
      this.$nextTick(function () {
        async.eachSeries(JSON.parse(JSON.stringify(this.filterItems)), function (holiday, cb) {
          vm.$store.dispatch('holidays/write', holiday).then(() => {
            cb()
          })
        }, function (error) {
          if (error) {
            console.log(error)
          }
          vm.onRefresh()
          vm.loading = false
        })
      })
    },
    onUpload () {
      var vm = this
      this.upload = false
      vm.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      pause(100).then(() => {
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['holidays/initial']))
        var temp = []
        var keys = Object.keys(this.selected)
        for (var i in keys) {
          if (this.selected[keys[i]]) {
            var index = this.items.findIndex(item => item.startDate === keys[i])
            if (index !== -1) {
              temp.push(this.items[index])
            }
          }
        }
        if (temp.length === 0) {
          vm.loading = false
          return
        }
        payload.name = temp[0].startDate + '_' + temp[temp.length - 1].startDate
        payload.events = temp
        payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
        vm.$store.dispatch('holidays/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.onReset()
          vm.loading = false
        })
      })
    },
    onRemoveDialog (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    onRemove () {
      console.log(this.items, this.item)
      var vm = this
      this.dialog = false
      this.$nextTick(function () {
        this.loading = true
        var payload = vm.item.key
        vm.$store.dispatch('holidays/delete', payload).then(() => {
          vm.onReset()
          vm.loading = false
        })
      })
    },
    onClose () {
      this.$emit('dismissed')
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onDismissed: function (value) {
      if (this.updateDialog) {
        this.updateDialog = false
        if (value) {
          this.onUpdate()
        }
        return
      }
      if (this.upload) {
        this.upload = false
        if (value) {
          this.onUpload()
        }
        return
      }
      if (this.dialog) {
        this.dialog = false
        if (value) {
          this.onRemove()
        }
      }
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}

input[type="file"]:focus {
  outline: 0 !important;
}

input[type="file"] {
  display: none;
}

.overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  line-height: 48px;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
